import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTrackOticAuth } from '@/context/TrackOticAuthContext';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { toast } from 'sonner';
import { Truck, Loader2 } from 'lucide-react';

export default function OpsLoginPage() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const { login, tenant } = useTrackOticAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const result = await login(email, password);
      toast.success(`Welcome, ${result.user.full_name}`);
      navigate('/ops/dashboard');
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Login failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-slate-950 flex items-center justify-center p-4">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <div className="inline-flex items-center justify-center w-16 h-16 bg-teal-600 rounded-xl mb-4">
            <Truck className="w-8 h-8 text-white" />
          </div>
          <h1 className="text-2xl font-bold text-white">Track<span className="text-red-500">0</span>tic Operations</h1>
          <p className="text-slate-400 mt-2">Cold Chain Monitoring Portal</p>
        </div>

        <div className="bg-slate-900 rounded-xl p-8 border border-slate-800">
          <form onSubmit={handleSubmit} className="space-y-6">
            <div className="space-y-2">
              <Label htmlFor="email" className="text-slate-300">Email</Label>
              <Input
                id="email"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="you@company.com"
                className="bg-slate-800 border-slate-700 text-white"
                required
                data-testid="ops-login-email"
              />
            </div>

            <div className="space-y-2">
              <Label htmlFor="password" className="text-slate-300">Password</Label>
              <Input
                id="password"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="••••••••"
                className="bg-slate-800 border-slate-700 text-white"
                required
                data-testid="ops-login-password"
              />
            </div>

            <Button 
              type="submit" 
              className="w-full bg-teal-600 hover:bg-teal-700"
              disabled={loading}
              data-testid="ops-login-submit"
            >
              {loading ? (
                <>
                  <Loader2 className="mr-2 h-4 w-4 animate-spin" />
                  Signing in...
                </>
              ) : (
                'Sign In'
              )}
            </Button>
          </form>

          <div className="mt-6 text-center">
            <a href="/ops/forgot-password" className="text-teal-400 hover:underline text-sm">
              Forgot password?
            </a>
          </div>
        </div>

        <p className="text-center text-slate-600 text-xs mt-8">
          Track<span className="text-red-500">0</span>tic by SentinelX Technology Pvt Ltd
        </p>
      </div>
    </div>
  );
}
